/**
 * PublicProjectsIndex — AG Grid table for /projects?view=table
 *
 * Migrated from Sprockets (app/assets/javascripts/public_projects_index.js)
 * to esbuild bundle with AG Grid v35 API updates.
 */
import $ from 'jquery';
import AgGridColumnFilters from '../v4/components/ag_grid_column_filters';
import AgGridPagination from '../v4/components/ag_grid_pagination';
import IndexSnapshotSaver from '../v4/components/index_snapshot_saver';

window.PublicProjectsIndex = {
    _gridApi: null,
    _gridOptions: null,
    _dataTable: [],
    _groupTable: [],
    _pivotMode: false,
    _currentRand: -1,
    _searchClass: null,

    _resizeTable() {
        return resizeAgGridTable('#projects-index-table', this._gridOptions, 0, false, 48);
    },

    clearData(rand) {
        this._currentRand = rand;
        this._dataTable = {};
        return this._gridApi.showLoadingOverlay();
    },

    loadNoData() {
        return this._gridApi.setGridOption('rowData', []);
    },

    _allFilled(pages) {
        return _.isEmpty(_.reject(Array.from({ length: pages }, (_, i) => i), x => {
            return this._dataTable[x] && (this._dataTable[x].length > 0);
        }));
    },

    loadSinglePageData(data) {
        this._gridApi.showLoadingOverlay();
        this.clearData();
        this._gridApi.setGridOption('rowData', data);
        $('#projects-index-table').parent().removeClass('hidden');
        $('#spinner').hide();
        this._resizeTable();
        return this._gridApi.hideOverlay();
    },

    _togglePagination() {
        $('#pagination').toggle(this._pivotMode);
        return $('#pagination-result').toggle(!this._pivotMode);
    },

    exportDataAsExcel(exportLimit) {
        let exportedRows = 0;
        return this._gridApi.exportDataAsExcel({
            fileName: 'projects_list',
            sheetName: 'Projects',
            headerRowHeight: 35,
            shouldRowBeSkipped(node, api, context) {
                exportedRows++;
                return exportedRows > exportLimit;
            }
        });
    },

    loadData(data, rand) {
        if (rand !== this._currentRand) { return; }
        this._dataTable[data.page] = data.hits;

        if (this._allFilled(data.nbPages)) {
            this._gridApi.setGridOption('rowData', _.flatten(_.values(this._dataTable)));
            $('#projects-index-table').parent().removeClass('hidden');
            $('#spinner').hide();
            this._resizeTable();
            return this._gridApi.hideOverlay();
        }
    },

    _participationRenderer(params) {
        return "<div class='participants'>" +
            `<div class='participants-icon has-tip.tip-left' title='${params.value} Participants' data-tooltip= ''></div>` +
            `<div class='participants-value'>${params.value}</div>` +
            '</div>';
    },

    _budgetRenderer(params) {
        if (params.data) {
            if (params.column.aggregationActive) {
                return params.data.formatted_budget;
            } else {
                return params.data.budget_text;
            }
        }
    },

    _budgetFormatter(params) {
        if (!params.value) { return; }
        let val = params.value;
        if (typeof (val) === 'object') {
            val = val.value;
        }
        if (!val) { return; }

        if (params.column.aggregationActive) {
            return numeral(val).format('($0[.]0a)').toUpperCase();
        } else {
            return val;
        }
    },

    _togglePivotLikeMode() {
        const tmpPivotMode = (this._groupTable.length !== 0);

        this._gridOptions.groupDefaultExpanded = this._groupTable.length - 1;

        if (tmpPivotMode !== this._pivotMode) {
            let tmpHitsNb;
            this._pivotMode = tmpPivotMode;

            const pivottedArray = ['formatted_budget_count', 'formatted_budget_sum', 'formatted_budget'];
            const notPivottedArray = [];
            $('.col-visibility input:checked').each(function () {
                return notPivottedArray.push($(this).attr('data-col-id'));
            });
            this._togglePagination();
            if (this._pivotMode) {
                tmpHitsNb = 10;
                // v35: columnApi merged into api
                this._gridApi.setColumnsVisible(pivottedArray, true);
                this._gridApi.setColumnsVisible(notPivottedArray, false);
            } else {
                tmpHitsNb = 24;
                this._gridApi.setColumnsVisible(notPivottedArray, true);
                this._gridApi.setColumnsVisible(pivottedArray, false);
            }

            this._getSearcherClass()._searchObject.helper.setQueryParameter('hitsPerPage', tmpHitsNb);
            this._getSearcherClass()._searchObject.refresh();
        }
        // v35: columnApi merged into api
        return this._gridApi.setRowGroupColumns(this._groupTable);
    },

    _changeGrouping(field, e) {
        $(e.target).siblings('.checkbox').toggleClass('checked', e.target.checked);
        this._groupTable = _.without(this._groupTable, field);
        if (e.target.checked) { this._groupTable.push(field); }
        return this._togglePivotLikeMode();
    },

    _compareStrings(a, b) {
        if (a === b) { return 0; }
        if (a > b) { return 1; } else { return -1; }
    },

    _compareEndDate(valA, valB) {
        if (!valA || !valB) { return 0; }
        const first = valA === '-' ? ['-', '-'] : valA.split(' ');
        const second = valB === '-' ? ['-', '-'] : valB.split(' ');

        if (first[1] === second[1]) {
            return this._compareStrings(first[0], second[0]);
        } else {
            return this._compareStrings(first[1], second[1]);
        }
    },

    _compareArrays(valA, valB, dataA, dataB, array) {
        if (dataA && dataB && dataA.data && dataB.data) {
            const field = array[0];
            const tmpArr = array.slice(1);

            const val = this._compareField(dataA.data, dataB.data, field);
            if ((val === 0) && (tmpArr.length > 0)) {
                return this._compareArrays(valA, valB, dataA, dataB, tmpArr);
            } else {
                return val;
            }
        } else {
            return this._compareGroupFields(valA, valB, array);
        }
    },

    _compareGroupFields(valA, valB, fields) {
        const tmpArr = fields.slice();
        const val = this._compareFieldValues(valA, valB, tmpArr.shift());
        if ((val === 0) && (tmpArr.length > 0)) {
            return this._compareGroupFields(valA, valB, tmpArr);
        } else {
            return val;
        }
    },

    _statusFieldMap: {
        cancelled: '0',
        completed: '1',
        under_design: '2',
        planning: '3',
        tender: '4',
        on_hold: '5',
        under_construction: '6'
    },

    _compareField(dataA, dataB, field) {
        if (field === 'end_year') {
            return this._compareEndDate(dataA['end_year'], dataB['end_year']);
        } else if (field === 'country') {
            return this._compareStrings(dataA['location'][2], dataB['location'][2]);
        } else if (field === 'city') {
            return this._compareStrings(dataA['location'][1], dataB['location'][1]);
        } else if (field === 'status') {
            return this._compareStrings(this._statusFieldMap[dataA['status']], this._statusFieldMap[dataB['status']]);
        } else {
            return this._compareStrings(dataA[field], dataB[field]);
        }
    },

    _compareFieldValues(valA, valB, field) {
        if (field === 'end_year') {
            return this._compareEndDate(valA, valB);
        } else {
            return this._compareStrings(valA, valB);
        }
    },

    _getSearcherClass() {
        switch (this._searchClass) {
            case 'CompanyProjects': return CompanyProjects;
            case 'PublicProjectsSearch': return PublicProjectsSearch;
        }
    },

    _initializeCookieSavers(preloadedCookies, path) {
        const cookieNames = [
            'projects-index-table-column-order',
            'projects-index-table-column-filters'
        ];

        return IndexSnapshotSaver.initialize(cookieNames, preloadedCookies, path).startSaving();
    },

    initialize(key, high_level_membership, searchClass, trial, userMembership, preloadedCookies) {
        // v35: LicenseManager accessible via global namespace
        if (agGrid && agGrid.LicenseManager) {
            agGrid.LicenseManager.setLicenseKey(key);
        }

        this._searchClass = searchClass;
        let columnDefs =
            [
                {
                    headerName: I18n.t('projects.index.headers.name'),
                    minWidth: 50,
                    suppressHeaderMenuButton: true,
                    field: 'title',
                    colId: 'title',
                    comparator() { return 0; },
                    cellRenderer(params) {
                        if (!params.data) { return; }
                        return `<a href='/projects/${params.data.slug}'>${params.value}</a>`;
                    }
                }
            ];

        if (high_level_membership || ((userMembership === 'insights') && trial)) {
            columnDefs = columnDefs.concat([
                {
                    headerName: I18n.t('projects.index.headers.type'),
                    minWidth: 10,
                    suppressHeaderMenuButton: true,
                    field: 'project_type.label',
                    colId: 'project_type',
                    sortable: false,
                    enableRowGroup: true
                }, {
                    headerName: I18n.t('projects.index.headers.status'),
                    minWidth: 10,
                    suppressHeaderMenuButton: true,
                    field: 'status',
                    colId: 'status',
                    enableRowGroup: true,
                    enablePivot: true,
                    filter: 'agSetColumnFilter',
                    comparator() { return 0; },
                    filterParams: {
                        cellRenderer(params) { return I18n.t(`enumerize.project.status.${params.value}`); }
                    },
                    cellClass(params) { return params.value; },
                    cellRenderer(params) {
                        const { value } = params;
                        const title = value ? I18n.t(`enumerize.project.status.${value}`) : '';
                        return `<div class='status-label auto label-project-status document-status ${value}'>${title}</div>`;
                    }
                }]);
        }

        if (high_level_membership) {
            columnDefs = columnDefs.concat([
                {
                    headerName: I18n.t('projects.index.headers.main_sectors'),
                    minWidth: 20,
                    field: 'categories',
                    sortable: false,
                    suppressHeaderMenuButton: true,
                }, {
                    headerName: I18n.t('projects.index.headers.sectors'),
                    minWidth: 20,
                    field: 'sectors',
                    sortable: false,
                    suppressHeaderMenuButton: true,
                }, {
                    headerName: I18n.t('projects.index.headers.budget'),
                    minWidth: 10,
                    field: 'formatted_budget',
                    colId: 'budget_text',
                    filter: 'agNumberColumnFilter',
                    enablePivot: true,
                    suppressHeaderMenuButton: true,
                    comparator() { return 0; },
                    cellRenderer: this._budgetRenderer
                }, {
                    headerName: I18n.t('projects.index.headers.contract_value'),
                    minWidth: 10,
                    field: 'contract_value',
                    colId: 'contract_value',
                    filter: 'agNumberColumnFilter',
                    suppressHeaderMenuButton: true
                }, {
                    headerName: I18n.t('projects.index.headers.floors_overground'),
                    minWidth: 10,
                    suppressHeaderMenuButton: true,
                    field: 'floors_overground',
                    colId: 'floors_overground',
                    enableRowGroup: true,
                    sortable: false
                }, {
                    headerName: I18n.t('projects.index.headers.hotel_keys'),
                    minWidth: 10,
                    suppressHeaderMenuButton: true,
                    field: 'hotel_keys',
                    colId: 'hotel_keys',
                    enableRowGroup: true,
                    sortable: false
                }, {
                    headerName: I18n.t('projects.index.headers.hotel_stars'),
                    minWidth: 10,
                    suppressHeaderMenuButton: true,
                    field: 'hotel_stars',
                    colId: 'hotel_stars',
                    enableRowGroup: true,
                    sortable: false,
                    valueGetter(params) {
                        if (params.data) { return params.data.non_numeric_attributes['Hotel Stars']; }
                    }
                }, {
                    headerName: I18n.t('projects.index.headers.hospital_beds'),
                    minWidth: 10,
                    suppressHeaderMenuButton: true,
                    field: 'hospital_beds',
                    colId: 'hospital_beds',
                    enableRowGroup: true,
                    sortable: false
                }, {
                    headerName: I18n.t('projects.index.headers.end_date'),
                    minWidth: 10,
                    enableRowGroup: true,
                    suppressHeaderMenuButton: true,
                    field: 'end_year',
                    colId: 'end_year',
                    comparator() { return 0; },
                    filter: 'agDateColumnFilter',
                    cellRenderer(params) {
                        if (!params.data) { return; }
                        return params.data.end_year;
                    },
                    valueGetter: params => {
                        if (!params.data) { return; }
                        if (this._groupTable.includes('end_year')) {
                            return params.data.end_year;
                        } else {
                            return new Date(params.data.ended_at * 1000);
                        }
                    }
                }, {
                    headerName: I18n.t('projects.index.headers.last_update'),
                    minWidth: 10,
                    suppressHeaderMenuButton: true,
                    filter: 'agDateColumnFilter',
                    comparator() { return 0; },
                    valueGetter(params) {
                        if (!params.data) { return; }
                        return new Date(params.data.formatted_updated_at);
                    },
                    field: 'formatted_updated_at',
                    colId: 'formatted_updated_at',
                    cellRenderer(params) {
                        if (!params.data) { return; }
                        return params.data.formatted_updated_at;
                    }
                }, {
                    headerName: `${I18n.t('projects.index.headers.budget')} Sum`,
                    minWidth: 10,
                    suppressHeaderMenuButton: true,
                    field: 'formatted_budget',
                    colId: 'formatted_budget_sum',
                    enableValue: true,
                    hide: true,
                    aggFunc: 'sum',
                    sortable: false,
                    valueGetter: this._budgetRenderer,
                    filter: 'agNumberColumnFilter',
                    valueFormatter: this._budgetFormatter
                }, {
                    headerName: `${I18n.t('projects.index.headers.budget')} Average`,
                    minWidth: 30,
                    suppressHeaderMenuButton: true,
                    field: 'formatted_budget',
                    colId: 'formatted_budget_average',
                    enableValue: true,
                    hide: true,
                    aggFunc: 'avg',
                    sortable: false,
                    valueGetter: this._budgetRenderer,
                    filter: 'agNumberColumnFilter',
                    valueFormatter: this._budgetFormatter
                }
            ]);
            columnDefs = columnDefs.concat(this._participantsInfoColumns());
        }

        columnDefs = columnDefs.concat([{
            headerName: I18n.t('projects.index.headers.city'),
            minWidth: 10,
            suppressHeaderMenuButton: true,
            field: 'city',
            colId: 'city',
            enableRowGroup: true,
            sortable: false,
            enablePivot: true,
            valueGetter(params) { if (params.data) { return params.data.location_terms.city; } }
        }, {
            headerName: I18n.t('projects.index.headers.country'),
            minWidth: 10,
            suppressHeaderMenuButton: true,
            colId: 'country',
            field: 'country',
            sortable: false,
            enableRowGroup: true,
            enablePivot: true,
            valueGetter(params) { if (params.data) { return params.data.location_terms.country; } }
        }]);

        this._gridOptions = {
            name: 'intelligence-projects-grid',
            paginationPageSize: 48,
            headerHeight: 44,
            rowHeight: 44,
            animateRows: false,
            pagination: true,
            suppressPaginationPanel: true,
            columnDefs,
            suppressCsvExport: true,
            suppressExcelExport: false,
            groupDefaultExpanded: 0,
            suppressAggFuncInHeader: true,
            suppressContextMenu: true,
            excelStyles: [{ id: "header", interior: { color: '#c6dfb5', pattern: 'Solid' }, font: { bold: true, size: 11 }, alignment: { vertical: ['Center'], horizontal: ['Center'], wrapText: true } }],
            onSortChanged: e => {
                if (this._pivotMode) { return; }
                // v35: getSortModel removed — use getColumnState instead
                const sortedCols = e.api.getColumnState().filter(c => c.sort);
                const model = sortedCols[0];
                if (model) {
                    let column = model.colId;
                    column = (() => {
                        switch (column) {
                            case 'end_year': return 'ended_at';
                            case 'formatted_updated_at': return 'updated_at';
                            case 'formatted_budget': return 'budget';
                            case 'budget_text': return 'budget';
                            default: return column;
                        }
                    })();
                    return AgGridHeadersSearch.setIndex(column, model.sort);
                } else {
                    return AgGridHeadersSearch.setDefaultIndex();
                }
            },

            defaultColDef: {
                sortable: true,
                resizable: true,
                filter: 'agTextColumnFilter',
                filterParams: { maxNumConditions: 1 },
                sortingOrder: ['asc', 'desc', null],
                suppressHeaderMenuButton: true
            },
            autoGroupColumnDef: {
                suppressHeaderMenuButton: false,
                filter: true,
                minWidth: 300,
                comparator: (valA, valB, nodeA, nodeB) => {
                    return this._compareArrays(valA, valB, nodeA, nodeB, _.flatten([this._groupTable, 'title']));
                },
                field: 'title',
                cellRendererParams: {
                    innerRenderer(params) {
                        if (params.data) {
                            return `<a href='/projects/${params.data.slug}'>${params.value}</a>`;
                        } else {
                            if (params.node.field === 'status') {
                                const translation = I18n.t(`enumerize.project.status.${params.value}`);
                                return `<div class='status-label auto label-project-status document-status ${params.value}'>${translation}</div>`;
                            } else {
                                return params.value;
                            }
                        }
                    }
                }
            },
            onGridReady(params) {
                return AgGridColumnFilters._adjustColumnsToFit();
            },
            onGridSizeChanged(params) {
                return AgGridColumnFilters._adjustColumnsToFit();
            },
            onDisplayedColumnsChanged(params) {
                return AgGridColumnFilters._adjustColumnsToFit();
            }
        };

        const gridDiv = document.getElementById('projects-index-table');
        // v35: createGrid replaces new agGrid.Grid()
        this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
        // Store api on gridOptions for backward compatibility with shared components
        this._gridOptions.api = this._gridApi;

        const agGridPagination = AgGridPagination.initialize(this._gridOptions);
        this._gridOptions.onPaginationChanged = agGridPagination.renderPagination.bind(agGridPagination);
        this._initializeCookieSavers(preloadedCookies, '/');
        AgGridPagination.initializePaginationListeners();
        AgGridColumnFilters.initialize(this._gridOptions, [], [], ['title', 'budget_text', 'city', 'country']);
        if (high_level_membership) {
            $('#grouping > #country').on('click', 'input', e => this._changeGrouping('country', e));
            $('#grouping > #city').on('click', 'input', e => this._changeGrouping('city', e));
            $('#grouping > #status').on('click', 'input', e => this._changeGrouping('status', e));
            $('#grouping > #end_year').on('click', 'input', e => this._changeGrouping('end_year', e));
        }

        return this._togglePagination();
    },

    _downloadXLSX(base64content) {
        const fileName = 'export.xlsx';
        const blobObject = this._base64toBlob(
            base64content,
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        );

        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blobObject);
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        return document.body.removeChild(downloadLink);
    },

    _participantsInfoColumns() {
        const participantsInfo = ['owner.company', 'owner.contacts', 'developer_1.company', 'developer_1.contacts', 'developer_2.company', 'developer_2.contacts', 'contractor_1.company', 'contractor_1.contacts', 'contractor_2.company', 'contractor_2.contacts', 'contractor_3.company', 'contractor_3.contacts', 'lead_consultant.company', 'lead_consultant.contacts', 'interior_designer.company', 'interior_designer.contacts', 'design_architect.company', 'design_architect.contacts', 'mep_engineer.company', 'mep_engineer.contacts', 'facade_consultant.company', 'facade_consultant.contacts', 'infrastructure_consultant.company', 'infrastructure_consultant.contacts', 'mep_contractor.company', 'mep_contractor.contacts', 'completion_percent', 'design_completed_at.label', 'contract_awarded_at.label', 'mep_contract_awarded_at.label'];
        const data = [];
        for (const info of participantsInfo) {
            data.push({
                headerName: I18n.t(`projects.index.headers.${info}`),
                minWidth: 70,
                suppressHeaderMenuButton: true,
                field: info,
                enableRowGroup: true,
                sortable: false,
                colId: info.replace(/\./g, '_')
            });
        }
        return data;
    },

    _base64toBlob(b64Data, contentType) {
        const sliceSize = 512;
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
        let offset = 0;
        while (offset < byteCharacters.length) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            let i = 0;
            while (i < slice.length) {
                byteNumbers[i] = slice.charCodeAt(i);
                i++;
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
            offset += sliceSize;
        }
        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
};



// Auto-init: read config from data-attributes on #projects-index-table
(function autoInitProjectsIndex() {
    function init() {
        var el = document.getElementById('projects-index-table');
        if (!el || el.getAttribute('data-auto-init') !== 'true') return;
        el.removeAttribute('data-auto-init'); // Prevent double-init

        var agKey = el.getAttribute('data-ag-key') || '';
        var highLevel = el.getAttribute('data-high-level') === 'true';
        var searchClass = el.getAttribute('data-search-class') || 'PublicProjectsSearch';
        var trial = el.getAttribute('data-trial') === 'true';
        var userMembership = el.getAttribute('data-user-membership') || '';
        var preloadedCookies = [];
        try {
            preloadedCookies = JSON.parse(el.getAttribute('data-preloaded-cookies') || '[]');
        } catch (e) { /* ignore parse errors */ }

        try {
            PublicProjectsIndex.initialize(agKey, highLevel, searchClass, trial, userMembership, preloadedCookies);
        } catch (e) {
            console.error('[PublicProjectsIndex] Auto-init failed:', e.message);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
